import { Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

import * as graphql from 'generated/graphql';
import ListFilterCheckbox from 'packages/kakapo-ui-application/pages/learning/components/ListFilterCheckbox';
import Accordion, { AccordionItem } from 'packages/kakapo-ui-kit/components/accordion/Accordion';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

function LearningFilterSubject() {
	const { localize } = useLocalize();

	const { data } = graphql.useLearningSubjectsQuery({ variables: { first: 1000 } });

	if (!data) {
		return <Spinner isLoading size="18" verticalMargin={0} />;
	}

	return (
		<ListFilterCheckbox
			options={data.learningSubjects.edges.map(({ node }) => ({
				label: localize(node.title)?.text,
				name: 'subjects',
				value: node.id,
			}))}
		/>
	);
}

function LearningFilterType() {
	const { localize } = useLocalize();

	const { data } = graphql.useLearningTypesQuery({ variables: { first: 1000 } });

	if (!data) {
		return <Spinner isLoading size="18px" verticalMargin={0} />;
	}

	return (
		<ListFilterCheckbox
			options={data.learningTypes.edges.map(({ node }) => ({
				label: localize(node.title)?.text,
				name: 'types',
				value: node.id,
				tintColor: node.color,
			}))}
		/>
	);
}

const LearningFilterSidebar = () => {
	const { t } = useTranslation();

	return (
		<Form>
			<Accordion>
				<AccordionItem
					title={t('learning.events.filters.eventTypes.title')}
					initialIsCollaped={false}
				>
					<LearningFilterType />
				</AccordionItem>

				<AccordionItem
					title={t('learning.events.filters.subject.title')}
					initialIsCollaped={isMobile}
				>
					<LearningFilterSubject />
				</AccordionItem>
			</Accordion>
		</Form>
	);
};

export default LearningFilterSidebar;
